export const formatCart = (cart) => ({
  ...cart,
  subtotal: cart?.total_price,
  lines: cart?.items,
});

export const formatCartLines = (lines) => {
  if (!lines) return [];
  return lines.map((line) => {
    const images = line.image;

    return {
      ...line.node,
      images,
    };
  });
};

export const formatProduct = (product) => ({
  ...product,
  images: formatProductImages(product?.images?.edges),
  variants: formatProductVariants(product?.variants?.edges),
  url: `/products/${product?.handle}`,
});

export const formatProductImages = (images) => {
  if (!images) return [];
  return images.map((image) => ({
    ...image.node,
    src: image.node.src,
    alt: image.node.altText,
  }));
};

export const formatProductVariants = (variants) => {
  if (!variants) return [];
  return variants.map((variant) => ({
    ...variant.node,
    price: Number(variant.node.price.amount) * 100,
    compareAtPrice: Number(variant.node.compareAtPrice?.amount) * 100,
    id: decodeIDProductVariant(variant.node.id),
  }));
};

export const decodeIDProductVariant = (id) => decodeURIComponent(id).split('gid://shopify/ProductVariant/')[1];